class reportTemplatePreview {
    constructor($scope, httpRequest, $stateParams) {
        const templateId = $stateParams.id
        $scope.templateUrl = '' // 模板的url
        // 获取模板预览的url
        const getReportTemplateUrl = async () => {
            try {
                const result = await httpRequest.post_previewReportTemplate(templateId)
                $scope.templateUrl = result.data.value.url
                $scope.$apply()
            } catch (e) {
                console.log(e)
            }
        }
        getReportTemplateUrl()
        // iframe 全屏显示
        $('#report-template-preview').load(function () {
            const mainheight = $(this).contents().find('body').height() + 30
            $(this).height(mainheight)
        })
    }
}

reportTemplatePreview.$inject = ['$scope', 'httpRequest', '$stateParams']

export default reportTemplatePreview



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/reportTemplateSetting/reportTemplatePreviewCtrl.js